import { ApiUrls } from '../endpoints';
import api from '../createApiClient';

export const getAllIssuers = async () => {
  try {
    const dataUrl = `${ApiUrls.issuer}/getAllIssuers`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all issuers:', error);
    throw error;
  }
};

export const getAllCompanyIssuers = async (IssuerID) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/company-issuers/${IssuerID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all company issuers:', error);
    throw error;
  }
};

export const getIssuer = async (IssuerID) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/getIssuerById/${IssuerID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting issuer:', error);
    throw error;
  }
};

export const getIssuerBadgeProfile = async (ProfileID) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/getIssuerBadgeProfile/${ProfileID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting issuer badge profile:', error);
    throw error;
  }
};

export const getIssuerUserId = async (IssuerID) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/getIssuerUserId/${IssuerID}`;
    const response = await api.get(dataUrl);
    return response.data.data;
  } catch (error) {
    console.error('Error getting issuer userid:', error);
    throw error;
  }
};

export const createIssuer = async (data) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/createIssuer`;
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error creating issuer:', error);
    throw error;
  }
};

export const updateIssuer = async (data) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/updateIssuerById`;
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error updating issuer:', error);
    throw error;
  }
};

export const deleteIssuer = async (IssuerID) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/deleteIssuerById/${IssuerID}`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting issuer:', error);
    throw error;
  }
};

export const deleteAllIssuers = async () => {
  try {
    const dataUrl = `${ApiUrls.issuer}/deleteAllIssuers`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting all issuers:', error);
    throw error;
  }
};

export const createIssuerByAdmin = async (data, adminID) => {
  try {
    const dataUrl = `${ApiUrls.base}/createIssuerByAdmin/${adminID}`;
    const response = await api.post(dataUrl, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating issuer by admin:', error);
    throw error;
  }
};

export const createCompanyIssuer = async (data, IssuerID) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/createCompanyIssuer/${IssuerID}`;
    const response = await api.post(dataUrl, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating company issuer:', error);
    throw error;
  }
};

export const createInvitedIssuer = async (firstName, lastName, email, password, issuerAdminUserID, issuerCompanyID) => {
  try {
    const dataUrl = `${ApiUrls.base}/createInvitedIssuer`;
    const data = {
      IssuerRepFirstName: firstName,
      IssuerRepLastName: lastName,
      IssuerRepEmailID: email,
      Password: password,
      IssuerAdminUserID: issuerAdminUserID,
      IssuerCompanyID: issuerCompanyID,
    }
    console.log(data)
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error creating invited issuer:', error);
    throw error;
  }
};

export const createInvitedCompanyIssuer = async (firstName, lastName, email, password, issuerID) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/createInvitedCompanyIssuer`;
    const data = {
      IssuerRepFirstName: firstName,
      IssuerRepLastName: lastName,
      IssuerRepEmailID: email,
      Password: password,
      CreatedByIssuerID: issuerID,
    }
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error creating invited company issuer:', error);
    throw error;
  }
};

export const inviteIssuerByEmail = async (IssuerRepEmailID, adminID, companyID) => {
  try {
    const dataUrl = `${ApiUrls.base}/inviteIssuerByEmail`;
    const data = {
      IssuerRepEmailID: IssuerRepEmailID,
      IssuerAdminUserID: adminID,
      IssuerCompanyID: companyID
    }
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error inviting issuer:', error);
    throw error;
  }
};

export const inviteCompanyIssuerByEmail = async (IssuerRepEmailID, IssuerID) => {
  try {
    const dataUrl = `${ApiUrls.issuer}/inviteCompanyIssuerByEmail`;
    const data = {
      IssuerRepEmailID: IssuerRepEmailID,
      CreatedByIssuerID: IssuerID
    }
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error inviting company issuer:', error);
    throw error;
  }
};
